"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummonLichAbilityHandler = exports.SummonLichActorAbilityFactory = exports.SummonLichAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
class SummonLichAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SummonLich;
        this.__typeName = "SummonLich";
    }
}
exports.SummonLichAbilityArgs = SummonLichAbilityArgs;
let SummonLichActorAbilityFactory = class SummonLichActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SummonLich", "Self", 1);
    }
};
SummonLichActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SummonLich")
], SummonLichActorAbilityFactory);
exports.SummonLichActorAbilityFactory = SummonLichActorAbilityFactory;
let SummonLichAbilityHandler = class SummonLichAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                const lichArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.NecromancerLich, invoker.level, 
                // attributes...
                Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
                    let multiplier = 1;
                    switch (+key) {
                        case __1.AttributeType.Will:
                            value = (0, __1.getValueOrDefault)(invoker.maxAttributeValues, __1.AttributeType.Focus, 0);
                            break;
                    }
                    pet[key] = Math.round(value * multiplier);
                    return pet;
                }, {}), {
                    [__1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("TouchOfTheDead").mk(),
                })
                    .withPlayerId(invoker.playerId);
                container.summonCompanion(sequence, ability.invokerId, lichArgs);
                if (container.hasAttribute(ability.invokerId, "Charm_Necromancer_1")) {
                    container.summonCompanion(sequence, ability.invokerId, lichArgs);
                }
            }
        });
    }
};
SummonLichAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SummonLich)
], SummonLichAbilityHandler);
exports.SummonLichAbilityHandler = SummonLichAbilityHandler;
